import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Contractors.css';
import SearchBar from 'components/shared/navigation/SearchBar';
import {
  goToContractor,
  loadContractorsRequest,
  newContractor,
} from 'actions/admin/contractors/contractors';
import {
  getContractors,
  getContractorsCurrentPage,
  getContractorsTotal,
  getContractorsPageSize,
} from 'selectors/admin/contractors/contractors';
import { loadTradesRequest } from 'actions/admin/work-orders/details/details';
import { getTrades } from 'selectors/admin/work-orders/work-orders';
import SimpleHeader from 'components/shared/table/SimpleHeader';
import SimpleTable from 'components/shared/table/SimpleTable';
import ContractorStatus from './ContractorStatus';
import Number from 'components/shared/text/Number';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import { getCurrentUser } from 'selectors/authentication';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import SimpleTruncate from 'components/shared/text/SimpleTruncate';

class Contractors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameToSearch: '',
      tradesFilter: '',
    };
  }

  componentDidMount() {
    this.props.dispatch(loadContractorsRequest(1));
    this.props.dispatch(loadTradesRequest());
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  handleAddContractor = (event) => {
    event.preventDefault();
    this.props.dispatch(newContractor());
  };

  handleContractorSelection = (index) => {
    simpleScrollToTop();
    this.props.dispatch(goToContractor(this.props.contractors[index].id));
  };

  handleTradesFilterSelect = (filter) => {
    this.props
      .dispatch(loadContractorsRequest(1, this.state.nameToSearch, filter))
      .then((response) => {
        if (response.ok) {
          this.setState({ tradesFilter: filter });
        }
      });
  };

  handleGenerateLink = (index) => {
    const { contractors } = this.props;
    return `contractors/${contractors[index].id}`;
  };

  mapContractors = (contractors) => {
    return contractors.map((contractor) => {
      return [
        <span className="h4">{contractor.name}</span>,
        <SimpleTruncate
          text={contractor.trades.map((trade) => trade.label).join('\n')}
        />,
        <ContractorStatus status={contractor.status} />,
        contractor.wo_in_progress_count,
        contractor.wo_complete_count,
        contractor.contact.first_name + ' ' + contractor.contact.last_name,
        contractor.total_earned !== null ? (
          <Number value={contractor.total_earned} format="$0,0" />
        ) : (
          'N/A'
        ),
      ];
    });
  };

  handleContractorsPageChange = (newPage) => {
    this.props.dispatch(loadContractorsRequest(newPage));
  };

  handleSearchTextChange = (value) => {
    this.setState({ nameToSearch: value });
    this.props.dispatch(loadContractorsRequest(1, value));
  };

  handleSearchTextClear = () => {
    this.handleSearchTextChange('');
  };

  render() {
    const { nameToSearch } = this.state;
    const {
      trades,
      contractors,
      contractorsCurrentPage,
      contractorsPageSize,
      contractorsTotal,
    } = this.props;
    const tradesHeaders = trades.map((trade) => ({
      id: `${trade.id}`,
      label: trade.label,
    }));
    return (
      <div className="contractors">
        <div className="full-title">Contractors</div>

        <div className="content-container">
          <SearchBar
            addButton={
              <input
                className={'btn button button-orange'}
                type="button"
                value="Add Contractor"
                onClick={this.handleAddContractor}
              />
            }
            searchPlaceHolder="Search by Name"
            searchText={nameToSearch}
            onSearchTextChange={this.handleSearchTextChange}
            onClearText={this.handleSearchTextClear}
            onSearch={this.handleSearchTextChange}
          >
            &nbsp;
          </SearchBar>

          <SimpleTable
            className="contractors-table"
            headers={[
              'COMPANY NAME',
              <SimpleHeader
                label="TRADES"
                filter={{
                  options: [{ id: '', label: 'All' }, ...tradesHeaders],
                  selected: this.state.tradesFilter,
                }}
                onFilterOptionSelect={this.handleTradesFilterSelect}
              />,
              'STATUS',
              'IN PROGRESS',
              'COMPLETED',
              'POC',
              'EARNINGS',
            ]}
            rows={this.mapContractors(contractors)}
            emptyMessage="No Contractors"
            onRowSelected={this.handleContractorSelection}
            onGenerateLink={this.handleGenerateLink}
          />

          <div className="pagination-container">
            <SimplePagination
              currentPage={contractorsCurrentPage}
              pageSize={contractorsPageSize}
              total={contractorsTotal}
              onPageChange={this.handleContractorsPageChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    contractors: getContractors(state),
    currentUser: getCurrentUser(state),
    contractorsCurrentPage: getContractorsCurrentPage(state),
    contractorsTotal: getContractorsTotal(state),
    contractorsPageSize: getContractorsPageSize(state),
    trades: getTrades(state),
  };
})(Contractors);



// WEBPACK FOOTER //
// ./src/components/admin/contractors/Contractors.js